import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var getBlockScreenTitle = function getBlockScreenTitle(blockType, dictionary) {
  if (blockType === 'temporary') {
    return "".concat(dictionary.t('com.login.2fa.temporary.block.title'));
  }

  return dictionary.t('com.login.2fa.permanent.block.title');
};
export var getModalTitle = function getModalTitle(dictionary, twoFactorDetails, blockType, isDesktop) {
  if (!isDesktop && (blockType || twoFactorDetails)) {
    return dictionary.t('com.login.title');
  }

  if (blockType) {
    return getBlockScreenTitle(blockType, dictionary);
  }

  if (twoFactorDetails) {
    return dictionary.t('com.login.2fa.confirmation');
  }

  return null;
};
export var getTwoFactorAnalyticEvent = function getTwoFactorAnalyticEvent(eventOverride) {
  return _objectSpread({
    flow: 'login',
    ux_ui: 'popup'
  }, eventOverride);
};
export var getTwoFactorAnalyticCodeType = function getTwoFactorAnalyticCodeType(contactType) {
  return contactType === 'EMAIL' ? 'email_code' : 'sms_code';
};
export var getTwoFactorAnalyticAlternativeCodeType = function getTwoFactorAnalyticAlternativeCodeType(contactType) {
  return contactType === 'EMAIL' ? 'send_by_email' : 'send_by_sms';
};
export var getTwoFactorAnalyticBlockType = function getTwoFactorAnalyticBlockType(blockType) {
  return blockType === 'permanent' ? 'block_profile' : 'temporary_block';
};